import React from 'react';
import PropTypes from 'prop-types';
import ResultsPaginator from './ResultsPaginator';

const CasesResults = ({ data, filter, onSearch }) => (
  <div id="ir-search-search-premium-results">
    <h2>
      Results – {data.num_cases} cases within {data.num_found} total matches
      <span className="ir-search-premium-reset">
        {/*TODO: set URL*/}
        {filter.grouped &&
          <a
            href=""
            className="active"
            onClick={e => { e.preventDefault(); onSearch({ ...filter, grouped: false, page: 0 }); }}
          >
            Display All Matching Entries
          </a>
        }
      </span>
    </h2>
    <table className="ir-search-table-results sticky-enabled">
      <thead>
        <tr>
          <th>Case Title</th>
          <th>Court</th>
          <th>Case No</th>
          <th>Chp</th>
          <th>Date&nbsp;Filed<br />Date&nbsp;Closed</th>
          <th>Matches</th>
        </tr>
      </thead>
      <tbody>
        {data.results.map((row, idx) => (
          <tr key={idx}>
            <td>{row.case_title}</td>
            <td className="ir-search-court" title={row.court_name}>{row.court}</td>
            <td className="ir-search-no-wrap" title={row.case_title}>
              <b>
                <a
                  href={`/rpc/legacy/case-menu-redirect/${row.court}/${row.case_no}`}
                  target="_blank">{row.case_no}
                </a>
              </b>
            </td>
            <td>{row.chapter}</td>
            <td>{row.date_filed || row.date_closed}</td>
            <td>{row.inner_hits}</td>
          </tr>
          ))
        }
      </tbody>
    </table>
    <ResultsPaginator
      totalPages={data.page_count}
      selectedPage={filter.page + 1 || 1}
      onChangePage={page => onSearch({ ...filter, page })}
    />
  </div>
);

CasesResults.propTypes = {
  data: PropTypes.any.isRequired,
};

export default CasesResults;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/CasesResults.jsx